import tokenService from '@utils/services/tokenServices'

export const isUserLoggedIn = () => {
  return !tokenService.isExpired()
}